import React from 'react';
import ReactDOM from 'react-dom';
import {VideoPlayer} from './videoPlayer/videoPlayer';

export default function (element, videoUrl, imageUrl) {
	ReactDOM.render(
		<VideoPlayer videoUrl={videoUrl} imageUrl={imageUrl} />
	, element)
}